<template>
  <footer class="footer">
    <div class="container">
      <div class="content">
        <p>
          <small>
            <strong>Portal do Emprego</strong> feito pela
            <a href="https://aeisep.pt" target="_blank"
              >Associação de Estudantes do ISEP</a
            >.
            <br />
            Para submeter ofertas de emprego contacte o Gabinete de Saídas
            Profissionais da aeISEP via email
            <a href="mailto:gsp@aeisep.pt">gsp@aeisep.pt</a>
          </small>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/TheFooter.vue